import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './ResetPasswordOTP.css';

export default function ResetPasswordOTP() {
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const navigate = useNavigate();

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setNewPassword(e.target.value);
  };

  const handleVerifyClick = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_URL}/api/reset-password`, {
        email: localStorage.getItem('queryemail'),
        otp: otp,
        newPassword: newPassword
    });
    
    if (response.data.success) {
        alert('Password reset successfully!');
        //step 1: store the auth token
               localStorage.setItem('authToken', response.data.token);
               localStorage.setItem('userName', response.data.user.name);
               localStorage.setItem('userEmail', response.data.user.email);
               localStorage.setItem('userPhone', response.data.user.phone);
               localStorage.setItem('userRole', response.data.user.role);
               localStorage.setItem('userUsedCodes', JSON.stringify(response.data.user.userCodes));
               //step 2: redirect the user to dashboard/home page
               navigate('/');
        
      }
    } catch (error) {
      console.error('Error resetting password:', error);
      alert(error.response?.data?.message || 'Failed to reset password. Please try again.');
    }
  };

  return (
    <>
      <h1>Reset Your Password</h1>
      <p>Enter the OTP sent to your email and your new password.</p>

      <form onSubmit={handleVerifyClick}>
        <label htmlFor="otp">Enter OTP:</label>
        <input
          type="text"
          id="otp"
          name="otp"
          value={otp}
          onChange={handleOtpChange}
          required
          placeholder="Enter OTP"
        />

        <label htmlFor="newPassword">New Password:</label>
        <input
          type="password"
          id="newPassword"
          name="newPassword"
          value={newPassword}
          onChange={handlePasswordChange}
          required
          placeholder="Enter new password"
        />

        <button type="submit">Reset Password</button>
      </form>
    </>
  );
}